export default __webpack_public_path__ + "static/media/drug2.a924a88d.png";